import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/defi/protocols")({
  component: () => <Outlet />,
});
